/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */

// Required side effectful code.
import './base_side_effects';

// TODO(mattSoulanille): Move this to base_side_effects.ts
// It is here for now because custom bundles need to avoid calling it, and they
// only replace the index.js file, not the base_side_effects file.
import {registerOptimizers} from './optimizers/register_optimizers';
registerOptimizers();

// All exports from this package should be in base.
export * from './base';
